import { useGetDownloadedSoundPackages } from '@bpm-web-app/swr-hooks';
import { createAppRoutes, DEFAULT_SOUNDS_LIMIT } from '@bpm-web-app/utils';
import { ClickableGenres } from '../../clickable-genres/clickable-genres';
import { SeeMoreLayout } from '../../see-more-layout/see-more-layout';

export const AccountDownloadsPacks = () => {
    const { data: soundPackages } = useGetDownloadedSoundPackages(
        {
            limit: DEFAULT_SOUNDS_LIMIT,
        },
        true
    );
    return (
        <SeeMoreLayout
            contentType="pack"
            pageTitle="Packs"
            count={soundPackages?.pagination?.total || 0}
            itemBasePath={createAppRoutes.packs}
            data={
                soundPackages?.data?.map((item) => ({
                    id: item.id,
                    image_url: item.artwork_url,
                    description: <ClickableGenres genres={item.Genre} />,
                    title: item.name,
                    slug: item.slug,
                })) ?? []
            }
        />
    );
};
